export interface TrackingUser {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string;
}

export interface TrackingShipment {
  id: string;
  shipmentStatus: string | null;
  deliveryTypeTo: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface TrackingItem {
  id: string;
  trackingId: string;
  shipmentId: string;
  userId: string;
  user: TrackingUser | null;
  shipment: TrackingShipment | null;
  createdAt?: string;
  updatedAt?: string;
}

export function getTrackingUserName(
  user: TrackingUser | null | undefined,
): string {
  if (!user) return "N/A";
  const first = user.firstName ?? user.first_name ?? "";
  const last = user.lastName ?? user.last_name ?? "";
  return `${first} ${last}`.trim() || "N/A";
}
